import React from 'react';
import PropTypes from 'prop-types';

function ProjectNoParameters({ message = 'Transferred from reaction results: no parameters' }) {
  return <div className="project-status-grid-item__no-results">{message}</div>;
}

ProjectNoParameters.propTypes = {
  message: PropTypes.string,
};

export default ProjectNoParameters;
